import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BaseSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#7DDB7A', // ON時のスイッチ色
      '& + .MuiSwitch-track': {
        backgroundColor: '#7DDB7A',
      },
    },
    padding: 8,
    '& .MuiSwitch-track': {
      backgroundColor: '#fff',
      borderRadius: 22 / 2,
      transition: theme.transitions.create(['background-color'], {
        duration: 300,
      }),
      '&::before, &::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 16,
        height: 16,
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: 16,
      height: 16,
      margin: 2,
    },
    '&.Mui-checked .MuiSwitch-track': {
      backgroundColor: '#7DDB7A',
    },
  }));